import { getTreatmentStatusLabelFromId } from "../../../lib/labels";

export default function DepartmentStatusPart({dataItem, classes}) {
    return <>
        {dataItem &&  <>
            <div className={classes.row}>Chiro: <b>{dataItem.chiro_status ? getTreatmentStatusLabelFromId(dataItem.chiro_status) : '-'}</b></div>                     
            <div className={classes.row}>PT: <b>{dataItem.pt_status ? getTreatmentStatusLabelFromId(dataItem.pt_status) : '-'}</b></div> 
            <div className={classes.row}>Medical: <b>{dataItem.medical_status ? getTreatmentStatusLabelFromId(dataItem.medical_status) : '-'}</b></div> 
        </>}
        
    </>
}